export var ResendTicketsStages;
(function (ResendTicketsStages) {
    ResendTicketsStages[ResendTicketsStages["Default"] = 0] = "Default";
    ResendTicketsStages[ResendTicketsStages["Loading"] = 1] = "Loading";
    ResendTicketsStages[ResendTicketsStages["Success"] = 2] = "Success";
    ResendTicketsStages[ResendTicketsStages["Error"] = 3] = "Error";
})(ResendTicketsStages || (ResendTicketsStages = {}));
